<template>
  <div class="card card__blank">
    <div class="card_item">
      <div class="card_img">
        <span class="card-picture"></span>
      </div>
      <div class="card_info">
        <div class="card_info-heading">
          <h2 class="heading2">
            {{ $t('Еще нет карты в личном кабинете?') }}
          </h2>
        </div>
        <div class="card_info-status"></div>
      </div>
      <div class="card_history">
        <p class="card-message">
          {{ $t('Карта Леста появится здесь вместе с первым возвратом внутриигровой валюты.') }}<br>
          {{ $t('При оформлении карты напрямую в банке не забудь привязать её к аккаунту. Совершай покупки и ожидай первого возврата внутриигровой валюты.') }}
        </p>
      </div>
        <div class="card_button-detail">
          <OrderButton variant="outlined" type="a" :href="orderLink">
            {{ $t('Заказать карту') }}
          </OrderButton>
        </div>
        <div class="card_button-main">
          <Button type="router-link" :to="{ name: 'bind' }">
            {{ $t('Привязать карту') }}
          </Button>
        </div>
    </div>
  </div>
</template>

<script>
import { Vue, Component } from 'vue-property-decorator'
import { State } from 'vuex-class'
import Button from '@/common/components/Button'
import OrderButton from '@/components/OrderButton'
import { getOrderUrl } from '@/helpers'

@Component({ components: { Button, OrderButton } })
class CardPlaceholder extends Vue {
  @State('country') currentCountry

  get orderLink () {
    return getOrderUrl(this.currentCountry)
  }
}

export default CardPlaceholder
</script>

<style lang="scss" src="./styles/card.scss"></style>
<style lang="scss" src="./styles/card-picture.scss"></style>
<style lang="scss" src="./styles/card-status.scss"></style>
<style lang="scss" src="./styles/card-details.scss"></style>
<style lang="scss" src="./styles/moneylist.scss"></style>
<style lang="scss" src="./styles/game-name.scss"></style>
<style lang="scss" src="./styles/card-history.scss"></style>
<style lang="scss" src="./styles/card-message.scss"></style>
